import React, { useEffect, useState } from 'react'
import Tabs from './Tabs'
import Details from '../../../../../Modules/Details/Details'
import Mappings from '../../../../../Modules/Mappings/Mappings'
import ManageEntities from '../../../../../Modules/ManageEntities/ManageEntities'

const SelectedConnector = (props) => {
    // Single source of truth for the open tab. It used to be mirrored in
    // localStorage and read back during render, which meant selecting the same tab
    // twice in a row bailed out of the re-render and the panel never switched.
    const [tabType, setTabType] = useState('Details')

    // Picking a different connector always lands on Details.
    useEffect(() => {
        setTabType('Details')
    }, [props.id])

    const activeTab = (selectedTab) => {
        props.getActiveTab(selectedTab)
        setTabType(selectedTab)
    }

    return (
        <>
            <div className='card-header bg-transparent'>
                <h4 className='card-title mb-2 card-title-wth-border titlecustomNew'>
                    {props.name ? props.name.replace(/^i95Dev\s*/, '') : ''}
                </h4>
                <Tabs getActiveTab={activeTab} activeTab={tabType} />
            </div>
            <div className='card-body pleft-0 pright-0'>
                <div className='row'>
                    {
                        tabType === "Mappings" ?
                        <Mappings
                            instancesId={props.instancesId}
                            connectorId={props.id}
                            sourceId={props.sourceId}
                            targetId={props.targetId}
                            sourceEndpointId={props.sourceEndpointId}
                            targetEndpointId={props.targetEndpointId}
                            id={props.id}
                            instance={props.instance}
                            sourceShortName={props.sourceShortName}
                            targetShortName={props.targetShortName}
                        /> :
                        tabType === "ManageEntities" ?
                        <ManageEntities
                            instancesId={props.instancesId}
                            connectorId={props.id}
                        /> :
                        <Details
                            businessEntitiesSource={props.businessEntitiesSource}
                            businessEntitiesTarget={props.businessEntitiesTarget}
                            sourceName={props.sourceName}
                            targetName={props.targetName}
                            sourceShortName={props.sourceShortName}
                            targetShortName={props.targetShortName}
                            instancesId={props.instancesId}
                            sourceId={props.sourceId}
                            targetId={props.targetId}
                            sourceVersion={props.sourceVersion}
                            targetVersion={props.targetVersion}
                            featureName={props.featureName}
                            isSetupCompleted={props.isSetupCompleted}
                            sourceType={props.sourceType}
                            targetType={props.targetType}
                            connectorId={props.id}
                        />
                    }
                </div>
            </div>
        </>
    )
}

export default SelectedConnector
